import React from 'react';
import { ProductPackOptionSelector } from '../OptionSelector/productOptionSelector';
import { formatContentfulComponentProps } from '../../../../../../utils/globals';

export const ProductPackOptionsSelector = ({
  productPackOptionList,
  productPackPicker,
}) => (
  <div className='flex w-full my-8 flex-col lg:flex-row'>
    {productPackOptionList.map((option, index) => (
      <>
        <ProductPackOptionSelector
          {...formatContentfulComponentProps(option.component)}
          {...formatContentfulComponentProps(productPackPicker)}
          index={index}
          products={option.products}
        />
      </>
    ))}
  </div>
);
